import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Adjust to '../AuthContext' or './components/Auth/AuthContext' if needed

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);
    return () => clearTimeout(timer);
  }, [isAuthenticated, children]);

  if (isLoading) {
    return <div className="min-h-screen bg-white flex items-center justify-center font-quicksand">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/SignIn" replace />;
  }

  if (!children) {
    console.error('ProtectedRoute: children is undefined');
    return <div>Error: Component not found</div>;
  }

  return children;
}

export default ProtectedRoute;